<script>
	// @ts-nocheck
	import { page } from '$app/stores';
	import { lang } from '$lib/translations/menu';
	import { goto } from '$app/navigation';
	import { fly, slide } from 'svelte/transition';

	export let item, OnPage, OpenMenu;
	let OpenDetail = false;
</script>

<!-- svelte-ignore a11y-no-static-element-interactions -->
<!-- svelte-ignore a11y-click-events-have-key-events -->
<div
	on:click={() => {
		if (item.children.length > 0) {
			OpenDetail = !OpenDetail;
		} else {
			goto(`/${item.slug}`);
			OpenMenu = false;
		}
	}}
	class="flex justify-between items-center border-b-[0.5px] border-custom-gray pr-[27px] pt-[20px] pl-[27px] pb-[18px]"
>
	<button class="text-2xl text-custom-white-bg">{item[`name${$page.data.host}`]}</button>
	<button class="text-2xl text-custom-white-bg">
		{#if OpenDetail}
			-
		{:else}
			+
		{/if}
	</button>
</div>
{#if OpenDetail}
	<div
		transition:slide
		class="bg-custom-dark-bg pr-[27px] pt-[20px] pl-[27px] pb-[18px] min-h-[30vh]"
	>
		<a
			on:click={() => {
				OpenMenu = false;
			}}
			class="text-lg col-span-1 text-custom-white-bg"
			href="/{item.slug}">{lang[$page.data.host]['seeAll']}</a
		>
		<div class="grid grid-cols-2">
			{#if item.children.length > 0}
				<div class="grid grid-cols-1">
					{#each item.children as children}
						<a
							on:click={() => {
								OpenMenu = false;
							}}
							class="text-lg text-custom-white-bg mt-6"
							href="/{children.slug}">{children[`name${$page.data.host}`]}</a
						>
					{/each}
				</div>
			{/if}
		</div>
	</div>
{/if}
